export default __webpack_public_path__ + "static/media/folder-tender-hammer-no-color.77832e15.svg";